module.exports = __webpack_public_path__ + "fonts/be-vietnam-pro-v8-latin-500.9b9a5c0.woff2";